import { AiFillCloseCircle } from "react-icons/ai";
import Modal from "../../../common/Modal";
import { useAdmin } from "../../../../context/admin";
import AdminService from "../../../../services/admin.service";
import { FormEvent } from "react";
import { useGlobal } from "../../../../context/global";

export default function ConfirmDeletePassenger() {
    const { setIsLoading } = useGlobal()
    const { confirmDeletePassengerId, setConfirmDeletePassengerId} = useAdmin()
        async function deletePassenger(e: FormEvent<HTMLFormElement>) {
            e.preventDefault()
            setIsLoading(true)
            try {
                await AdminService.deletePassenger(confirmDeletePassengerId!)
                window.location.reload()
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
    return (
        <Modal
        onSubmit={deletePassenger}
        >
            <h1>Are you sure you want to delete this passenger?</h1>
            <p>This information cannot be restored, you will also delete any sale, reservation, or register related to this passenger.</p>
            <div className="actions" 
            style={{ margin: '15px 0'}}
            >
                <button style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                >Delete</button>
                <button
                onClick={() => setConfirmDeletePassengerId(undefined)}
                type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none', margin: '0 10px'}}
                >Cancel</button>
            </div>
            <div className="close" onClick={() => setConfirmDeletePassengerId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}